import { request } from './index';
import { ExamOverviewType } from './exam';

export type PackageType = {
  id: number;
  name: string;
  status: boolean;
  exams: ExamOverviewType[];
  discountPercent: number;
  price: number;
  examCount: number;
  description: string;
};

export async function fetchPackages({
  queryKey: [_, search]
}: {
  queryKey: [string, string];
}): Promise<PackageType[]> {
  return await request(true, { url: `/packages/packages?${search}` });
}
